import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=3841a771&"
import script from "./profile-detail.ts?vue&type=script&lang=ts&"
export * from "./profile-detail.ts?vue&type=script&lang=ts&"
import style0 from "./profile-detail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports